
import { mapState, mapActions } from "vuex";
import currencyConverter from "../common/currency-converter.vue";
import AddToCart from "../cart/add-to-cart.vue";
import MenuOrderItemTextDraft from "../menu-order/menu-order-item-text-draft.vue";

export default {
  props: {
    cartItem: {
      type: Object,
      required: true
    }
  },
  components: { currencyConverter, AddToCart, MenuOrderItemTextDraft },
  data() {
    return {};
  },
  computed: {
    ...mapState("menu", ["taxes"]),
    shouldShowMenuOrderItemTextDraft() {
      return (
        (this.cartItem.item_addons?.items?.length || 0) > 0 ||
        (this.cartItem.variants?.items?.length || 0) > 0 ||
        (this.cartItem.item_groups?.items?.length || 0) > 0
      );
    }
  },
  methods: {
    ...mapActions("menu", ["getTaxes", "getAddons"]),
    ...mapActions("order", ["updateCart"]),
    handleItemDelete() {
      this.updateCart({
        menuItems: [
          {
            ...this.cartItem,
            menuId: this.cartItem.id,
            quantity: 0
          }
        ]
      });
    }
  }
};
